import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {SharedImports} from '@shared/shared-imports';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {UserSOICampaignDonationModel} from '@app/models/user-soi-campaign-donation.model';
import {SOICampaignModel} from '@app/models/soi-campaigns.model';
import {PiiValidateModel} from '@app/models/pii-validate.model';
import {take} from 'rxjs/operators';
import {ConfirmationService} from 'primeng/api';
import {UserSoiCampaignDonationService} from '@services/user-soi-campaign-donation.service';
import {GenericSelectModel} from '@app/models/generic-select.model';
import {LookupsDataService} from '@services/lookups-data.service';
import {ContextService} from '@services/context.service';
import {AddressModel} from '@app/models/addresses.model';
import {AddressFormCustomComponent} from '@shared/components/address-form-custom/address-form-custom.component';


@Component({
    selector: 'app-campaign-page-1',
    templateUrl: './page-1-contact.component.html',
    styleUrls: ['./page-1-contact.component.scss'],
    imports: [
        SharedImports, AddressFormCustomComponent ]
})

export class Page1ContactComponent implements OnInit, OnChanges {
  mainForm: FormGroup;
  recurring: boolean = false;
  isSearching: boolean = false;
  inputObjState: GenericSelectModel;
  setStateId: number;
  incomingAddressMailing = {} as AddressModel;
  setWorkLevelId: number;
  inputObjWorkLevel: GenericSelectModel;
  amounts: any[] = [];
  @Output() next = new EventEmitter<any>();
  @Output() updateData = new EventEmitter<any>();
  @Input() campaignProfile: UserSOICampaignDonationModel;
  @Input() campaignId: number;
  @Input() orgCampaignDetails: SOICampaignModel;

  constructor(private router: Router, private location: Location, private formBuilder: FormBuilder,
              private userSoiCampaignDonationService : UserSoiCampaignDonationService, private confirmationService: ConfirmationService,
              private lookupsDataService: LookupsDataService, public contextService: ContextService, private changeDetection: ChangeDetectorRef) {
    this.mainForm = this.formBuilder.group({
      firstName: new FormControl(null, [Validators.required]),
      lastName: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required, Validators.email]),
      mobile: new FormControl(null, [Validators.required]),
      address: new FormControl(null, [Validators.required]),
      address2: new FormControl(null),
      city: new FormControl(null, [Validators.required]),
      state: new FormControl(null, [Validators.required]),
      zipCode: new FormControl(null, [Validators.required]),
      zip4: new FormControl(null),
      contributionAmount: new FormControl(null, [Validators.required]),
    });
  }

  ngOnInit() {
    document.querySelector('.page-container-public').scrollIntoView(true);

  }

  ngOnChanges(changes: SimpleChanges) {
    this.mainForm.get('firstName').setValue(this.campaignProfile.FirstName);
    this.mainForm.get('lastName').setValue(this.campaignProfile.LastName);
    this.mainForm.get('email').setValue(this.campaignProfile.UserEmail);
    this.mainForm.get('mobile').setValue(this.campaignProfile.SecondaryPhoneNumber);
    this.mainForm.get('contributionAmount').setValue(this.campaignProfile.ContributionAmount);
    // this.setWorkLevelId = this.mainForm.get('workLevel').value;
    this.mainForm.get('address').setValue(this.campaignProfile.Address1);
    this.mainForm.get('address2').setValue(this.campaignProfile.Address2);
    this.mainForm.get('city').setValue(this.campaignProfile.City);
    this.mainForm.get('state').setValue(this.campaignProfile.StateProvinceID);
    this.setStateId = this.campaignProfile.StateProvinceID;
    this.mainForm.get('zipCode').setValue(this.campaignProfile.Zip);


    this.incomingAddressMailing.Zip = this.campaignProfile.Zip;
    this.incomingAddressMailing.Address1 = this.campaignProfile.Address1;
    this.incomingAddressMailing.Address2 = this.campaignProfile.Address2;
    this.incomingAddressMailing.City = this.campaignProfile.City;
    this.incomingAddressMailing.StateProvinceID = this.campaignProfile.StateProvinceID;
    if(changes.orgCampaignDetails && this.orgCampaignDetails.ContributionAmounts) {
      this.orgCampaignDetails.ContributionAmounts.forEach(x => {
        this.amounts.push({value: x, description: '$' + x});
      });
    }
    //fix later to reload custom atts.
    if(changes.campaignProfile && this.campaignProfile?.CustomAttributes && this.campaignProfile?.CustomAttributes[0]?.Value) {
      this.campaignProfile.CustomAttributes.forEach(personAtt => {
        this.orgCampaignDetails.CustomAttributes.forEach(orgAtt => {
          if(personAtt.CustomFieldID === orgAtt.CustomFieldID) {
            orgAtt.Value = personAtt.Value;
          }
        });
      });
      this.changeDetection.detectChanges();
    }
    this.initData();
  }

  initData() {
    this.mainForm.valueChanges.subscribe(data => {
      this.campaignProfile.FirstName = this.mainForm.get('firstName').value;
      this.campaignProfile.LastName = this.mainForm.get('lastName').value;
      this.campaignProfile.UserEmail = this.mainForm.get('email').value;
      this.campaignProfile.SecondaryPhoneNumber = this.mainForm.get('mobile').value;
      this.campaignProfile.Address1 = this.mainForm.get('address').value;
      this.campaignProfile.Address2 = this.mainForm.get('address2').value;
      this.campaignProfile.City = this.mainForm.get('city').value;
      this.campaignProfile.StateProvinceID = this.mainForm.get('state').value;
      this.campaignProfile.Zip = this.mainForm.get('zipCode').value;
      this.campaignProfile.OrganizationID = this.orgCampaignDetails.OrganizationID;

      this.updateData.emit(this.campaignProfile);
      if(this.orgCampaignDetails.ContributionAmounts?.length === 1) {
        this.campaignProfile.ContributionAmount = this.orgCampaignDetails.ContributionAmounts[0];
      }

    });
  }


  setAddress(addressChanges: AddressModel): void {
    if (addressChanges) {
      this.mainForm.markAsDirty();
      //this.campaignProfile.CountryID = 1;
      this.campaignProfile.Address1 = addressChanges.Address1;
      this.campaignProfile.Address2 = addressChanges.Address2;
      this.campaignProfile.City = addressChanges.City;
      this.campaignProfile.StateProvinceID = addressChanges.StateProvinceID;
      this.campaignProfile.Zip = addressChanges.Zip;
      this.mainForm.get('address').setValue(addressChanges.Address1);
      this.mainForm.get('address2').setValue(addressChanges.Address2);
      this.mainForm.get('city').setValue(addressChanges.City);
      this.mainForm.get('state').setValue(addressChanges.StateProvinceID);
      this.mainForm.get('zipCode').setValue(addressChanges.Zip);
    }
  }

  updateCustomFieldData(index: number, event:any): void {
    this.campaignProfile.CustomAttributes[index].Value = event.Value;
  }


  validatePii(key: string, value: string): void {
    this.isSearching = true;
    const piiData: PiiValidateModel = {
      SSN: null,
      SIN: null,
      PrimaryEmailAddress: null,
      PersonID: null,
      MatchType: key
    };
    piiData[key] = value;
    this.userSoiCampaignDonationService.validatePii(piiData)
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          this.isSearching = false;
          const baseURI = document.baseURI;
          if (res.MatchType) {
            const ref = this.confirmationService.confirm({
              header: 'Duplicate User(s) Found',
              icon: 'fas fa-exclamation-triangle',
              message: `This email is already in use. Please <a href="${baseURI}">log into your account</a> to update your supporter profile.`,
              acceptVisible: false,
              rejectLabel: 'Cancel'
            });
            this.mainForm.get('email').setValue(null);
          }
        }
      });
  }

  isItValid(): boolean {
    let tempInValid: boolean = false;
    this.campaignProfile.CustomAttributes?.forEach((attr: any) => {
      if(attr.Required === true && attr.Value === null) {
        tempInValid = true;
      }
    });
    return tempInValid;
  }

  goToNextPage() {
    const tempAddress = {} as AddressModel;
    this.campaignProfile.ContributionAmount = this.mainForm.get('contributionAmount').value;
    tempAddress.Address1 = this.campaignProfile.Address1;
    tempAddress.Address2 = this.campaignProfile.Address2;
    tempAddress.City = this.campaignProfile.City;
    tempAddress.StateProvinceID = this.campaignProfile.StateProvinceID;
    tempAddress.Zip = this.campaignProfile.Zip;
    this.incomingAddressMailing = tempAddress;
    this.next.emit();
  }

}
